import { render, staticRenderFns } from "./InformationLabels.vue?vue&type=template&id=c4d46ce2&"
import script from "./InformationLabels.vue?vue&type=script&lang=ts&"
export * from "./InformationLabels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports